import { ICellRendererParams } from "ag-grid-community";

import type { RequestRow } from "../requestLogGridTypes";

import { HydrationPendingCell, isRequestRowHydrating } from "./HydrationPendingCell";

const getScoreColors = (score: number): [string, string] => {
  if (score >= 80) {
    return ["bg-green-50", "text-green-500"];
  }
  if (score >= 60) {
    return ["bg-orange-50", "text-orange-500"];
  }
  return ["bg-red-50", "text-red-500"];
};

export const ScoreCellRenderer = ({ data }: ICellRendererParams<RequestRow>) => {
  if (isRequestRowHydrating(data)) {
    return <HydrationPendingCell />;
  }

  const score = data?.score;
  if (!score || typeof score !== "object") {
    return <span className="text-gray-400">-</span>;
  }

  if (score.default !== undefined) {
    const colors = getScoreColors(score.default);
    return (
      <span className={`${colors[0]} rounded-full px-4 py-2 font-medium ${colors[1]}`}>
        {score.default}
      </span>
    );
  }

  return <span className="text-gray-400">-</span>;
};
